import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SnackBar from "../../Components/Navbar/SnackBar";
import { authServies } from "../../services/authServices";
import { logoutUser } from "../Auth/authSlice";
import { openErrorSnack, openSnackBar } from "../modals/snackBarSlice";

const initialState = {
  home: {},
  pending: true,
  errors: {},
};

export const getDevHome = createAsyncThunk(
  "/home/getDevHome/",
  async (param = null, { dispatch, getState }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const { dev } = getState((state) => state.dev);
      console.log(dev.dev.id);
      const response = await authServies.http.get(`/api/home/`);
      return response.data.data;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data.errors;
      }
      return error.response;
    }
  }
);

export const createDevHome = createAsyncThunk(
  "/home/createDevHome/",
  async (logs, { dispatch, getState }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const { home } = getState((state) => state.home);
      console.log(home.home.id);
      const response = await authServies.http.post(`/api/home/`, logs);
      console.log(response.data.data);
      dispatch(openSnackBar({ message: "home slice created successfully" }));

      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data;
      }
      if (error.response.status === 429) {
        dispatch(
          openErrorSnack({
            message: ` ${error.response.data.message} , try after some seconds`,
          })
        );
        return error.response.data;
      }
      return error.response;
    }
  }
);

export const updateDevHome = createAsyncThunk(
  "/home/updateDevHome/",
  async (logs, { dispatch, getState }) => {
    console.log(logs);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const { home } = getState((state) => state.home);
      console.log(home.home.id);
      const response = await authServies.http.put(
        `/api/home/${home.home.id}`,
        logs
      );
      dispatch(openSnackBar({ message: "home slice updated successfully" }));

      console.log(response.data.data);
      return response;
    } catch (error) {
      if (error.response.status === 401) {
        dispatch(
          openErrorSnack({ message: "please sign in to perfom this action" })
        );
        dispatch(logoutUser());
      }
      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response.data.message,
          })
        );
      }
      if (error.response.status === 422) {
        dispatch(openErrorSnack({ message: error.response.data.message }));
        return error.response.data.errors;
      }
      return error.response;
    }
  }
);

const homeSlice = createSlice({
  name: "homeSlice",
  initialState,
  reducers: {},
  extraReducers: {
    [getDevHome.pending]: (state, action) => {
      const result = action.payload;
      state.pending = true;
    },
    [getDevHome.fulfilled]: (state, action) => {
      state.pending = false;
      const result = action.payload;
      state.home = action.payload;
      console.log(result);
    },
    [getDevHome.rejected]: (state, action) => {
      const result = action.payload;
      state.pending = false;
      console.log(result);
    },
    [updateDevHome.pending]: (state, action) => {
      const result = action.payload;
      state.pending = true;
      console.log(result);
    },
    [updateDevHome.fulfilled]: (state, action) => {
      const result = action.payload;
      state.pending = false;
      console.log(result);
    },
    [updateDevHome.rejected]: (state, action) => {
      const result = action.payload;
      state.pending = false;
      console.log(result);
    },
    [createDevHome.pending]: (state, action) => {
      const result = action.payload;
      state.pending = true;
    },
    [createDevHome.fulfilled]: (state, action) => {
      const result = action.payload;
      console.log(result);
    },
    [createDevHome.rejected]: (state, action) => {
      const result = action.payload;
      console.loog(result);
    },
  },
});

export default homeSlice.reducer;
